import {MemberState} from '../reducers/member'

export const isUserLoggedIn = (state: MemberState) => state.user?.loggedIn
